module.exports = __webpack_public_path__ + "img/CM-SL-CA-BMW-Lifestyle.ab17802a.jpeg";